import React, { useRef, useState } from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { useStaticQuery, graphql } from "gatsby";
import cx from "classnames";

import Select, { SelectOption } from "./Select";
import "./phoneSelect.less";

const PhoneSelect = ({
  className,
  defaultValue,
  onChange,
  onBlur,
  onFocus: onFocusFromProps,
}) => {
  const { t } = useTranslation("support");
  const [countrySearch, setCountrySearch] = useState("");
  const countrySearchInput = useRef();
  const selectInput = useRef();

  const phoneCodes = useStaticQuery(graphql`
    query PhoneCodesQuery {
      allPhoneCodesJson {
        edges {
          node {
            code
            dial_code
            name
          }
        }
      }
    }
  `);

  const sorterByLabel = (optionA, optionB) =>
    optionA.displayLabel.localeCompare(optionB.displayLabel);

  const getPopupContainer = () => selectInput.current;

  const focusCountryInput = () =>
    countrySearchInput.current.focus({ preventScroll: true });
  const onFocus = (e) => {
    focusCountryInput();
    if (onFocusFromProps) {
      onFocusFromProps(e);
    }
  };

  const sortedPhoneCodes = phoneCodes.allPhoneCodesJson.edges
    .slice()
    .sort((a, b) => a.node.name.localeCompare(b.node.name));

  return (
    <div ref={selectInput}>
      <Select
        getPopupContainer={getPopupContainer}
        name="phonecode"
        className={cx("select-prefix phone-select flex-none", className)}
        dropdownClassName="phone-select-dropdown"
        placeholder={t("Code")}
        optionLabelProp="displayLabel"
        optionFilterProp="displayLabel"
        filterSort={sorterByLabel}
        defaultValue={defaultValue}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onSelect={() => setCountrySearch("")}
        dropdownRender={(menu) => (
          <>
            <input
              ref={countrySearchInput}
              className="w-full font-mulish text-14 tracking-2 p-12 outline-none border border-gray-med focus:border-blue-ayana"
              placeholder="Search Country..."
              value={countrySearch}
              onChange={(e) => setCountrySearch(e.target.value)}
            />
            {menu}
          </>
        )}>
        {sortedPhoneCodes
          .filter((obj) =>
            obj.node.name.toLowerCase().startsWith(countrySearch.toLowerCase())
          )
          .map((obj) => {
            return (
              <SelectOption
                key={obj.node.code}
                value={obj.node.dial_code}
                displayLabel={`+${obj.node.dial_code}`}>
                {obj.node.name} (+{obj.node.dial_code})
              </SelectOption>
            );
          })}
      </Select>
    </div>
  );
};
PhoneSelect.defaultProps = {
  className: "",
  defaultValue: null,
};

export default PhoneSelect;
